<template>
  <div id="header-home-image">

    <div id="header-top">
      <div id="banner" class="home-localise-cta xs-flex xs-justify-start xs-items-center xs-flex-column home-localise-cta--c5 xs-mnb-30 md-mb-0">
<!--        <h1 class="logo-home xs-shrink-0 screenreader-only xs-my-5" style="z-index: 1000;">Pizza Hut</h1>-->
      </div>
    </div>
    <div v-if="showLocation" data-module-name="localisation-tool" data-module-placement="hero"
         class="home-localise-content xs-z-200 new-disposition ">
      <div class="home-maintain-center" v-show="$const.isShowMessageMaintain">
        <strong>{{$t('maintain.message_title')}}</strong><br />
        {{$t('maintain.message_content')}}
      </div>
      <div class="localisation-form xs-relative xs-mx-auto xs-z-400">
        <home-localization-map-zipcode-new v-if="showNewVariantDisposition"></home-localization-map-zipcode-new>
        <home-localization-map-zipcode v-else></home-localization-map-zipcode>
        <home-re-order v-if="reorderLastOrder && $auth.check()"></home-re-order>
      </div>
    </div>
  </div>


</template>
<script>
import HomeLocalizationMap from './HomeLocalizationMap.vue'
import HomeLocalizationMapZipcode from './HomeLocalizationMapZipcode.vue'
import UserTopMobile from '../partials/UserTopMobile'
import HomeReOrder from './HomeReOrder.vue'
import HomeLocalizationMapZipcodeNew from './HomeLocalizationMapZipcodeNewDesign.vue'
import { getExperiment } from '@pizza-hut/lib-experiments/lib'

export default {
  components: {
    HomeLocalizationMap,
    HomeLocalizationMapZipcode,
    UserTopMobile,
    HomeReOrder,
    HomeLocalizationMapZipcodeNew
  },
  props: {
    showLocation: {
      type: Boolean,
      default: true
    },
  },
  mounted () {
    const experiment = getExperiment('CVR', 'newDisposition')
    if (experiment === this.getValueExperiment('newDisposition', 'clickToOpenPopup') ||
      experiment === this.getValueExperiment('newDisposition', 'openAfterRedirectToMenu')) {
        this.showNewVariantDisposition = true
      } else if (experiment === null || this.getValueExperiment('newDisposition', 'controlVariant')) {
        this.showNewVariantDisposition = false
      // this.sendEventGA(this, 'CVR', 'newDisposition', 'oldDesign', null, true)
    }
  },
  created () {
    this.getConfigTenant()
    // const checkLayout = getExperiment('CVR', 'reOrderLastOrder')
    // if (checkLayout === this.getValueExperiment('reOrderLastOrder', 'showLastOrder')) {
    //   this.ABtesttingLastOrder = true
    //   this.getConfigTenant()
    // }
    // if (checkLayout === null) {
    //   this.sendEventGA(this, 'CVR', 'reOrderLastOrder', 'notShowLastOrder', null, false)
    // }
  },
  data () {
    return {
      lang: this.$session.get('lang'),
      flag: false,
      reorderLastOrder: 0,
      ABtesttingLastOrder: false,
      showNewVariantDisposition: false
    }
  },
  methods: {
    toggleLogin () {
      this.flag = !this.flag
    },
    changeLang (la) {
      this.lang = la
      this.$store.dispatch('setLang', la)
      this.$session.set('lang', la)
      this.$router.go(this.$router.currentRoute)
    },
    getConfigTenant () {
      let vm = this
      let params = {
        manual: 1
      }
      vm.axios.apiTenant.getConfigByClient(params, function (response) {
        vm.reorderLastOrder = response.data.data.item && response.data.data.item.reorder_last_order ? response.data.data.item.reorder_last_order : 0
      })
    }
  }
}
</script>
<style scoped>
  .home-maintain-center {
    padding: 5px 5px 20px;
    position: relative;
    font-size: 18px;
    color: red;
    font-weight: bold;
    text-align: center;
    background: #fff;
    margin-bottom: 10px;
  }
  @media only screen and (max-width: 800px)  {
    .home-maintain-center {
      font-size: 16px;
      padding: 5px;
      top: -60px;
    }
  }
  .dropdown-lang button {
    border: none;
  }
  .dropdown-lang .dropdown-menu>li>a{
    padding: 3px 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeTop.vue